import { type DataCollector, lazyRegisterDataCollectorIfNotRegistered, } from "owa-diagnostics-data-collection";
import loc from "owa-localize";
import { templateImportDiagnosticDataDescription } from "./registerTemplateImportDiagnosticsCallback.locstring.json";
import { getTemplateImportSteps } from "./registerTemplateImportDataCollector";

export async function registerTemplateImportDiagnosticsCallback(): Promise<void> {
    const templateImportDataCollector: DataCollector = {
        dataCollectionAction: () => Promise.resolve(JSON.stringify({ importSteps: getTemplateImportSteps() })),
        name: "TemplateImport",
        odsFileDescription: "Template import funnel steps",
        description: loc(templateImportDiagnosticDataDescription),
    };
    
    await lazyRegisterDataCollectorIfNotRegistered.importAndExecute(templateImportDataCollector);
}
